import React from 'react';
import LeftRight from "../../components/ui/LeftRight";
import s1 from "../../assets/images/products/pages/work-flow/1.png";
import s2 from "../../assets/images/products/pages/work-flow/2.png";
import s3 from "../../assets/images/products/pages/work-flow/3.png";
import { cFlowCardInfo, cFlowSecondaryCard } from "../../constants/data";
import SlideUp from "../../components/ui/SlideUp";
import { cFlowMeta } from "../../constants/meta";
import Meta from "../../components/common/Helmet";
import { useTranslation } from "react-i18next";

const WorkFlow = () => {
  const { t } = useTranslation();

  return (
    <div>
      <Meta
        title={cFlowMeta.title}
        description={cFlowMeta.description}
        canonical={cFlowMeta.canonical}
        keywords={cFlowMeta.keywords}
        ogTitle={cFlowMeta.title}
        ogDescription={cFlowMeta.description}
      />
      <div className="md:w-theme-container w-mobile-container mx-auto px-4 py-12 space-y-16">
        <div className="w-1/4 flex justify-center md:mx-auto">
          <img
            src={require('../../assets/images/logo/c-flow.png')}
            alt="c-flow work flow software"
          />
        </div>
        <div className="mt-12">
          <LeftRight
            subtitle={t('cFlowPage.cFlow')}
            titleClass={'text-gray-900'}
            isLeft={true}
            textPosition={'justify-center'}
            descriptionPosition={'text-left'}
            descriptionList={[
              t('cFlowPage.section1.desc1'),
              t('cFlowPage.section1.desc2'),
            ]}
            listGroup={[
              t('cFlowPage.section1.list1'),
              t('cFlowPage.section1.list2'),
              t('cFlowPage.section1.list3'),
              t('cFlowPage.section1.list4'),
              t('cFlowPage.section1.list5'),
              t('cFlowPage.section1.list6'),
            ]}
            icon={false}
            image={s1}
          />
        </div>
        <div className="mt-12">
          <LeftRight
            title={t('cFlowPage.section2.title')}
            subtitle={t('cFlowPage.section2.subtitle')}
            titleClass={'text-gray-900'}
            isLeft={false}
            textPosition={'justify-center'}
            listGroup={[
              t('cFlowPage.section2.list1'),
              t('cFlowPage.section2.list2'),
              t('cFlowPage.section2.list3'),
              t('cFlowPage.section2.list4'),
              t('cFlowPage.section2.list5'),
            ]}
            icon={false}
            image={s2}
          />
        </div>
        <div className="mt-12">
          <LeftRight
            title={t('cFlowPage.section3.title')}
            subtitle={t('cFlowPage.section3.subtitle')}
            titleClass={'text-gray-900'}
            isLeft={false}
            textPosition={'justify-center'}
            descriptionList={[t('cFlowPage.section3.desc1')]}
            listGroup={[
              t('cFlowPage.section3.list1'),
              t('cFlowPage.section3.list2'),
              t('cFlowPage.section3.list3'),
              t('cFlowPage.section3.list4'),
            ]}
            icon={false}
            image={s3}
          />
        </div>
        <div className="mt-12">
          <LeftRight
            title={t('cFlowPage.section4.title')}
            subtitle={t('cFlowPage.section4.subtitle')}
            titleClass={'text-gray-900'}
            isLeft={true}
            textPosition={'justify-center'}
            listGroup={[
              t('cFlowPage.section4.list1'),
              t('cFlowPage.section4.list2'),
              t('cFlowPage.section4.list3'),
              t('cFlowPage.section4.list4'),
              t('cFlowPage.section4.list5'),
              t('cFlowPage.section4.list6'),
            ]}
            secondListGroup={[
              t('cFlowPage.section4.list7'),
              t('cFlowPage.section4.list8'),
              t('cFlowPage.section4.list9'),
              t('cFlowPage.section4.list10'),
              t('cFlowPage.section4.list11'),
            ]}
            icon={false}
          />
        </div>
      </div>
      <div className="bg-[#08141A]">
        <div className="md:w-theme-container w-mobile-container mx-auto py-20">
          <h2 className="flex justify-center items-center text-white md:w-[40%] mx-auto text-xl xl:text-xl md:text-2xl theme-font-bold uppercase mb-14">
            {t('cFlowPage.keyPoints')}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
            {cFlowCardInfo.map((item) => (
              <div key={item.id} className="bg-white p-5 w-full shadow rounded-lg">
                <SlideUp>
                  <p className="text-left text-xl mb-3">{t(`cFlowPage.${item.title}`)}</p>
                  {item.description?.map((desc, index) => (
                    <div key={index} className="flex mb-2">
                      <div className="mr-2">-</div>
                      <div className="text-gray-700 md:text-xl">{t(`cFlowPage.${desc}`)}</div>
                    </div>
                  ))}
                </SlideUp>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="add-square-bg">
        <div className="md:w-theme-container w-mobile-container mx-auto py-20">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
            {cFlowSecondaryCard.map((item) => (
              <SlideUp key={item.id}>
                <div className="bg-[#08141A] p-5 w-full shadow rounded-lg h-44">
                  <p className="text-left text-white text-xl mb-3">{t(`cFlowPage.${item.title}`)}</p>
                  {item.description?.map((desc, index) => (
                    <div key={index} className="flex mb-2 text-white">
                      <div className="mr-2">-</div>
                      <div className="text-gray-300 md:text-xl">{t(`cFlowPage.${desc}`)}</div>
                    </div>
                  ))}
                </div>
              </SlideUp>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkFlow;
